import { ListItemIconProps as MuiListItemIconProps } from '@mui/material/ListItemIcon/ListItemIcon';
import { forwardRef } from 'react';
import MuiListItemIcon from '@mui/material/ListItemIcon';

export interface ListItemIconProps extends MuiListItemIconProps {
  /**
   * Spacing props between the icon and the rest of the content, MUI's default is regular.
   */
  fit?: 'tight' | 'compact' | 'regular';
}

const ListItemIcon = forwardRef<unknown, ListItemIconProps>((props, ref) => {
  const { ...other } = props;

  return <MuiListItemIcon ref={ref} {...other} />;
});

ListItemIcon.displayName = 'ListItem.Icon';

export default ListItemIcon;
